
import {  Outlet } from "react-router-dom";

export default function MonthInvoice(params) {

    return<div className="main-panel"> <div className="content-wrapper"><Outlet/></div></div> 
}